import React from 'react';
import { AuthCompanyContext } from '../providers';
import { redirectToUrl } from '../utils/redirect-to-url';

export const useRedirectToExternalLink = (): ((url: string) => void) => {
  const { currentCompany, currentMarket } = React.useContext(AuthCompanyContext);
  const redirect = (url: string) => redirectToUrl({ currentCompany, currentMarket, url });
  return redirect;
};
